module.exports = __webpack_public_path__ + "img/iphone-x-flying-socratix-mockup.172bf268.png";